import { Card, CardBody, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { BillingDetails, CheckOutTitle, ECommerce } from "../../../../Constants/Constants";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import CheckoutTableData from "./CheckoutTableData";
import ProductCheckout from "./ProductCheckout";
import { Fragment } from "react/jsx-runtime";

const CheckOutContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={CheckOutTitle} parent={ECommerce} />
      <Container fluid>
        <Card className="checkout">
          <CommonCardHeader title={BillingDetails} headClass="pb-0"/>
          <CardBody>
            <Row>
              <CheckoutTableData />
              <ProductCheckout />
            </Row>
          </CardBody>
        </Card>
      </Container>
    </Fragment>
  );
};

export default CheckOutContainer;
